<template>
  <div class="row-box">
    <WrapperField
      v-for="(fieldValue, fieldName) in data"
      :key="fieldValue + fieldName + Math.random()"
      :data="
        createDataField({
          fieldName,
          fieldValue,
          fieldGroup: FieldGroup.SUBJECT_DETAILS,
        })
      "
    />
  </div>
</template>

<script>
import { createDataField, FieldGroup } from '@/utils/fullStatementView';
import WrapperField from '@/components/elements/statement/FullStatementView/base/WrapperField';

export default {
  name: 'Details',
  components: {
    WrapperField,
  },
  props: ['data'],
  data: () => ({
    createDataField,
    FieldGroup,
  }),
};
</script>

<style scoped></style>
